// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gridItem {
    border: 1px double #ccc;
    border-radius: 30px;
    padding: 10px;
    margin-bottom: 0px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    width: 1000px;
    height: 270px;
    background-color: #501d1b;
    -webkit-backdrop-filter: saturate(200%) blur(30px);
            backdrop-filter: saturate(200%) blur(30px);
    color: #FFFFFF;
  }

.gridItemAcceptedTraining {
  border: 1px double #ccc;
  border-radius: 30px;
  padding: 10px;
  margin-bottom: 0px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  width: 1000px;
  height: 350px;
  background-color: #501d1b;
  -webkit-backdrop-filter: saturate(200%) blur(30px);
          backdrop-filter: saturate(200%) blur(30px);
  color: #FFFFFF;
}

.gridItemRecommended {
    border: 1px double #ccc;
    border-radius: 30px;
    padding: 10px;
    margin-bottom: 0px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    width: 1000px;
    height: 240px;
    background-color: #501d1b;
    -webkit-backdrop-filter: saturate(200%) blur(30px);
            backdrop-filter: saturate(200%) blur(30px);
    color: #FFFFFF;
  }

  .gridItemRecuritedTC {
    border: 1px double #ccc;
    border-radius: 30px;
    padding: 10px;
    margin-bottom: 0px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    width: 1000px;
    height: 300px;
    background-color: #501d1b;
    -webkit-backdrop-filter: saturate(200%) blur(30px);
            backdrop-filter: saturate(200%) blur(30px);
    color: #FFFFFF;
  }

  .gridItemSeeMore {
    border: 1px double #ccc;
    border-radius: 30px;
    padding: 16px;
    margin-bottom: 0px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    width: 500px;
    /* height: 240px; */
    background-color: #501d1b;
    -webkit-backdrop-filter: saturate(200%) blur(30px);
            backdrop-filter: saturate(200%) blur(30px);
    color: #FFFFFF !important;
  }

  .gridItemTC {
    border: 1px double #ccc;
    border-radius: 30px;
    padding: 10px;
    margin-bottom: 0px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    width: 1000px;
    height: 230px;
    background-color: #501d1b;
    -webkit-backdrop-filter: saturate(200%) blur(30px);
            backdrop-filter: saturate(200%) blur(30px);
    color: #FFFFFF !important;
  }

  .gridItemTrainingList {
    border: 1px double #ccc;
    border-radius: 30px;
    padding: 16px;
    margin-bottom: 30px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    width: 1000px;
    background-color: #501d1b;
    -webkit-backdrop-filter: saturate(200%) blur(30px);
            backdrop-filter: saturate(200%) blur(30px);
    color: #FFFFFF;
  }

  .gridItemRecommendedTC {
    border: 1px double #ccc;
    border-radius: 30px;
    padding: 10px;
    margin-bottom: 0px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    width: 600px;
    height: 270px;
    background-color: #501d1b;
    -webkit-backdrop-filter: saturate(200%) blur(30px);
            backdrop-filter: saturate(200%) blur(30px);
    color: #FFFFFF;
  }

  .gridItemAcceptedTraining, .gridItemAcceptedTraining * {
    color: #FFFFFF !important; /* Set font color to white */
  }

  .gridItemTC, .gridItemTC * {
    color: #FFFFFF !important; /* Set font color to white */
  }
  
  .gridItemRecuritedTC, .gridItemRecuritedTC * {
    color: #FFFFFF !important; /* Set font color to white */
  }

  .gridItemRecommendedTC, .gridItemRecommendedTC * {
    color: #FFFFFF !important; /* Set font color to white */
  }

  .gridItem, .gridItem * {
    color: #FFFFFF !important; /* Set font color to white */
  }

  .gridItemSeeMore, .gridItemSeeMore * {
    color: #FFFFFF !important; /* Set font color to white */
  }

  .gridItemTrainingList, .gridItemTrainingList * {
    color: #FFFFFF !important; /* Set font color to white */
  }
  
  .trainingInfo {
    display: flex;
    flex-direction: column;
  }
  
  .trainingName {
    margin-top: -10px;
    margin-bottom: 5px;
    font-size: medium;
  }

  .trainingNameSeeMore {
    margin-top: -10px;
    margin-bottom: 5px;
    font-size: medium;
  }

  .trainingNameActive {
    margin-top: -10px !important; 
    margin-bottom: 8px !important;
    font-size: medium !important;
  }

  .gridContent {
    padding: 13px;
  }

  .gridContentSeeMore {
    padding: 8px;
  }


  `, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,kDAA0C;YAA1C,0CAA0C;IAC1C,cAAc;EAChB;;AAEF;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,kDAA0C;UAA1C,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,kDAA0C;YAA1C,0CAA0C;IAC1C,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,kDAA0C;YAA1C,0CAA0C;IAC1C,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kDAA0C;YAA1C,0CAA0C;IAC1C,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,kDAA0C;YAA1C,0CAA0C;IAC1C,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,yBAAyB;IACzB,kDAA0C;YAA1C,0CAA0C;IAC1C,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kDAA0C;YAA1C,0CAA0C;IAC1C,cAAc;EAChB;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd","sourcesContent":[".gridItem {\n    border: 1px double #ccc;\n    border-radius: 30px;\n    padding: 10px;\n    margin-bottom: 0px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    width: 1000px;\n    height: 270px;\n    background-color: #501d1b;\n    backdrop-filter: saturate(200%) blur(30px);\n    color: #FFFFFF;\n  }\n\n.gridItemAcceptedTraining {\n  border: 1px double #ccc;\n  border-radius: 30px;\n  padding: 10px;\n  margin-bottom: 0px;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n  width: 1000px;\n  height: 350px;\n  background-color: #501d1b;\n  backdrop-filter: saturate(200%) blur(30px);\n  color: #FFFFFF;\n}\n\n.gridItemRecommended {\n    border: 1px double #ccc;\n    border-radius: 30px;\n    padding: 10px;\n    margin-bottom: 0px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    width: 1000px;\n    height: 240px;\n    background-color: #501d1b;\n    backdrop-filter: saturate(200%) blur(30px);\n    color: #FFFFFF;\n  }\n\n  .gridItemRecuritedTC {\n    border: 1px double #ccc;\n    border-radius: 30px;\n    padding: 10px;\n    margin-bottom: 0px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    width: 1000px;\n    height: 300px;\n    background-color: #501d1b;\n    backdrop-filter: saturate(200%) blur(30px);\n    color: #FFFFFF;\n  }\n\n  .gridItemSeeMore {\n    border: 1px double #ccc;\n    border-radius: 30px;\n    padding: 16px;\n    margin-bottom: 0px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    width: 500px;\n    /* height: 240px; */\n    background-color: #501d1b;\n    backdrop-filter: saturate(200%) blur(30px);\n    color: #FFFFFF !important;\n  }\n\n  .gridItemTC {\n    border: 1px double #ccc;\n    border-radius: 30px;\n    padding: 10px;\n    margin-bottom: 0px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    width: 1000px;\n    height: 230px;\n    background-color: #501d1b;\n    backdrop-filter: saturate(200%) blur(30px);\n    color: #FFFFFF !important;\n  }\n\n  .gridItemTrainingList {\n    border: 1px double #ccc;\n    border-radius: 30px;\n    padding: 16px;\n    margin-bottom: 30px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    width: 1000px;\n    background-color: #501d1b;\n    backdrop-filter: saturate(200%) blur(30px);\n    color: #FFFFFF;\n  }\n\n  .gridItemRecommendedTC {\n    border: 1px double #ccc;\n    border-radius: 30px;\n    padding: 10px;\n    margin-bottom: 0px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    width: 600px;\n    height: 270px;\n    background-color: #501d1b;\n    backdrop-filter: saturate(200%) blur(30px);\n    color: #FFFFFF;\n  }\n\n  .gridItemAcceptedTraining, .gridItemAcceptedTraining * {\n    color: #FFFFFF !important; /* Set font color to white */\n  }\n\n  .gridItemTC, .gridItemTC * {\n    color: #FFFFFF !important; /* Set font color to white */\n  }\n  \n  .gridItemRecuritedTC, .gridItemRecuritedTC * {\n    color: #FFFFFF !important; /* Set font color to white */\n  }\n\n  .gridItemRecommendedTC, .gridItemRecommendedTC * {\n    color: #FFFFFF !important; /* Set font color to white */\n  }\n\n  .gridItem, .gridItem * {\n    color: #FFFFFF !important; /* Set font color to white */\n  }\n\n  .gridItemSeeMore, .gridItemSeeMore * {\n    color: #FFFFFF !important; /* Set font color to white */\n  }\n\n  .gridItemTrainingList, .gridItemTrainingList * {\n    color: #FFFFFF !important; /* Set font color to white */\n  }\n  \n  .trainingInfo {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .trainingName {\n    margin-top: -10px;\n    margin-bottom: 5px;\n    font-size: medium;\n  }\n\n  .trainingNameSeeMore {\n    margin-top: -10px;\n    margin-bottom: 5px;\n    font-size: medium;\n  }\n\n  .trainingNameActive {\n    margin-top: -10px !important; \n    margin-bottom: 8px !important;\n    font-size: medium !important;\n  }\n\n  .gridContent {\n    padding: 13px;\n  }\n\n  .gridContentSeeMore {\n    padding: 8px;\n  }\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
